import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from '../../utils/customBaseQuery';

export const subscriptionsApi = createApi({
	reducerPath: "subscriptionsApi",
	baseQuery: customBaseQuery,
	refetchOnFocus: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		// POST /create — создание подписок
		createSubscription: builder.mutation({
			query: (data) => ({
				url: "/create",
				method: "POST",
				body: data,
				prefix: "subscription"
			}),
		}),

		// GET /all — получить все подписки с параметрами title, category, time
		allSubscriptions: builder.query({
			query: (params) => ({
				url: "/all",
				method: "GET",
				params,
				prefix: "subscription"
			}),
		}),

		// GET /:id — получить одну подписку по id
		getSubscriptionById: builder.query({
			query: (id) => `/${id}`,
			prefix: "subscription"
		}),

		// PUT /:id — обновить подписку
		updateSubscriptionById: builder.mutation({
			query: ({ id, data }) => ({
				url: `/${id}`,
				method: "PUT",
				body: data,
				prefix: "subscription"
			}),
		}),

		// DELETE /:id — удалить подписку
		deleteSubscriptionById: builder.mutation({
			query: (id) => ({
				url: `/${id}`,
				method: "DELETE",
				prefix: "subscription"
			}),
		}),
	}),
});

export const {
	useCreateSubscriptionMutation,
	useAllSubscriptionsQuery,
	useGetSubscriptionByIdQuery,
	useUpdateSubscriptionByIdMutation,
	useDeleteSubscriptionByIdMutation,
} = subscriptionsApi;
